/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationMember } from '../models/NotificationMember';
import type { NotificationSettings } from '../models/NotificationSettings';
import type { NotificationSettingsUpdate } from '../models/NotificationSettingsUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationSettingsService {
    /**
     * The caller's email notification settings in this workspace, and every member's
     * @param workspaceId The workspace the settings apply to
     * @returns any Settings; defaults for any the member never changed
     * @throws ApiError
     */
    public static getNotificationSettings(
        workspaceId: string,
    ): CancelablePromise<{
        data?: NotificationSettings;
        members?: Array<NotificationMember>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/notification-settings',
            query: {
                'workspace_id': workspaceId,
            },
        });
    }
    /**
     * Change some of the caller's email notification settings, or another member's
     * @param workspaceId The workspace the settings apply to
     * @param requestBody
     * @returns any All of that member's settings after the change
     * @throws ApiError
     */
    public static putNotificationSettings(
        workspaceId: string,
        requestBody: NotificationSettingsUpdate,
    ): CancelablePromise<{
        data?: NotificationSettings;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/notification-settings',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `user_id is not a member of this workspace`,
            },
        });
    }
}
